import React from 'react';
import { motion } from 'framer-motion';
interface DiaryEntryProps {
  date: string;
  title: string;
  content: React.ReactNode;
  delay?: number;
}
export function DiaryEntry({
  date,
  title,
  content,
  delay = 0
}: DiaryEntryProps) {
  return <motion.article initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.7,
    delay
  }} className="relative mb-12" data-id="element-17">
      <div className="absolute -left-3 top-8 bottom-0 w-px bg-stone-200 hidden sm:block" data-id="element-18"></div>
      <div className="absolute -left-[17px] top-8 w-3 h-3 rounded-full bg-brand-amber hidden sm:block border-4 border-stone-50" data-id="element-19"></div>

      <div className="sm:pl-8" data-id="element-20">
        <div className="mb-3" data-id="element-21">
          <span className="font-sans text-sm font-bold text-brand-amber uppercase tracking-wider" data-id="element-22">
            {date}
          </span>
          <h2 className="text-2xl font-bold text-brand-brown mt-1 font-sans" data-id="element-23">
            {title}
          </h2>
        </div>

        <div className="diary-paper p-6 sm:p-8 rounded-lg border border-stone-200 text-lg leading-[2rem] text-stone-700" data-id="element-24">
          {content}
        </div>
      </div>
    </motion.article>;
}